import { gql } from "@apollo/client";

export const CREATE_REASON_OF_LOSS_MEMBER = gql`
  mutation CreateReasonOfLossMember($input: ReasonOfLossMemberInput) {
    createReasonOfLossMember(input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const GET_REASON_OF_LOSS_MEMBER_WITH_PAGINATION = gql`
  query GetReasonOfLossMemberPagination(
    $page: Int
    $limit: Int
    $keyword: String
    $pagination: Boolean
  ) {
    getReasonOfLossMemberPagination(
      page: $page
      limit: $limit
      keyword: $keyword
      pagination: $pagination
    ) {
      data {
        _id
        reason_title
        isDefault
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const UPDATE_REASON_OF_LOSS_MEMBER = gql`
  mutation UpdateReasonOfLossMember($input: ReasonOfLossMemberInput, $id: ID!) {
    updateReasonOfLossMember(input: $input, _id: $id) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const DELETE_REASON_OF_LOSS_MEMBER = gql`
  mutation DeleteReasonOfLossMember($id: ID!) {
    deleteReasonOfLossMember(_id: $id) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;
